import React, { useState, useEffect, useRef, useCallback } from 'react';
import './CompleteLandingPage.css';

// Dados dos slides para facilitar a manutenção
const slides = [
  
  {
    image: "/prints/pdv-desktop.png",
    alt: "Tela de Ponto de Venda (PDV) do CripSYS",
    title: "Frente de Caixa (PDV)",
    description: "Registre vendas rapidamente, gerencie mesas ou comandas e aceite diversas formas de pagamento com uma interface intuitiva."
  },
  {
    // Novo slide para a tela KDS (Kitchen Display Screen)
    image: "/prints/kds-desktop.png", // Certifique-se que esta imagem exista em /public/prints
    alt: "Tela KDS (Kitchen Display Screen) do CripSYS",
    title: "KDS - Otimização Total na Cozinha",
    description: "Envie pedidos do PDV direto para a cozinha em tempo real, organizando a produção e reduzindo o tempo de preparo dos pratos."
  },
  {
    image: "/prints/dashboardREAL-desktop.png",
    alt: "Dashboard de Análises do CripSYS",
    title: "Dashboard de Análise de Faturamento",
    description: "Visualize o desempenho do seu negócio com gráficos de faturamento, ticket médio e produtos mais vendidos."
  },

  {
    image: "/prints/comandas-desktop.png",
    alt: "Painel de comandas do CripSYS",
    title: "Painel de Vendas em Tempo Real",
    description: "Acompanhe comandas abertas de forma organizada em tempo real."
  },
  
];

const SystemCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  // Função para resetar o timer da troca automática
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  // Funções de navegação usando useCallback para otimização
  const goToPrevious = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex]);

  const goToNext = useCallback(() => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex]);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  // Efeito para a troca automática de slides a cada 5 segundos
  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(goToNext, 5000);

    // Limpa o timeout quando o componente é desmontado
    return () => {
      resetTimeout();
    };
  }, [currentIndex, goToNext]);

  return (
    <section id="demo-carousel" className="lp-demo-section lp-carousel-section">
      <div className="lp-section-header lp-animate-on-scroll">
        <div className="lp-section-badge">Visão Geral</div>
        <h2>Conheça nosso sistema em ação</h2>
        <p>Navegue pelas capturas de tela das principais funcionalidades da plataforma.</p>
      </div>
      <div className="lp-carousel-container lp-animate-on-scroll">
        
        {/* Botões de Navegação */}
        <button onClick={goToPrevious} className="lp-carousel-control lp-carousel-prev" aria-label="Slide anterior">
          <svg viewBox="0 0 24 24" width="24" height="24"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <button onClick={goToNext} className="lp-carousel-control lp-carousel-next" aria-label="Próximo slide">
          <svg viewBox="0 0 24 24" width="24" height="24"><path d="M9 18l6-6-6-6" /></svg>
        </button>

        {/* Wrapper que se move */}
        <div className="lp-carousel-wrapper" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {slides.map((slide, index) => (
            <div className="lp-carousel-slide" key={index}>
              <img src={slide.image} alt={slide.alt} className="lp-carousel-image" />
              <div className="lp-carousel-caption">
                <h3>{slide.title}</h3>
                <p>{slide.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Indicadores (bolinhas) */}
        <div className="lp-carousel-indicators">
          {slides.map((_, slideIndex) => (
            <button
              key={slideIndex}
              className={`lp-carousel-indicator ${currentIndex === slideIndex ? 'lp-active' : ''}`}
              onClick={() => goToSlide(slideIndex)}
              aria-label={`Ir para o slide ${slideIndex + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemCarousel;